import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {Alert, Button, Col, Form, Input, message, Row, Select, Space, Spin, Typography} from 'antd';
import {withRouter} from 'react-router';
import {FileAddOutlined} from '@ant-design/icons';
import {getArtistSaleReport} from '../../api/artistSaleReports';
import {URL_INCOME_PAYMENT} from '../../const';
import HttpError from '../../component/base/HttpError';
import {getAllArtistNames} from "../../api/artistNames";
import {postArtistPayments} from "../../api/artistPayments";

const {Title} = Typography
const {Option} = Select

const d = new Date()
const date = d.toLocaleDateString('en-CA');

const mapStateToProps = function (state) {
    return {
        artistId: state.user.info.artistId,
    }
}
export default withRouter(connect(mapStateToProps)(NewPayment));

function NewPayment(props) {
    const [loading, setLoading] = useState(false)
    const [actionLoading, setActionLoading] = useState(false)
    const [artistNames, setArtistNames] = useState([])
    const [orderNum, setOrderNum] = useState("")
    const ref = useRef(null)

    useEffect(() => {
        setLoading(true)
        getAllArtistNames().then((response) => {
            const artists = response.data
            setArtistNames(artists)
        }).catch((error) => {
            HttpError(error)
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    const onCancelButtonClick = () => {
        if (props.history) props.history.push({pathname: URL_INCOME_PAYMENT})
    }

    const submitPayment = (values) => {
        if (!props.artistId) return
        let today = new Date()
        const dd = String(today.getDate()).padStart(2, '0')
        const mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
        const yyyy = today.getFullYear()
        today = yyyy + '-' + mm + '-' + dd
        if (isNaN(values.artwork_price)) message.error("Error value for artwork price: " + values.artwork_price).then(() => {
        })
        if (isNaN(values.revart_commission)) message.error("Error value for commission: " + values.revart_commission).then(() => {
        })

        const total_payment = parseFloat(values.artwork_price) - parseFloat(values.revart_commission)
        if (isNaN(total_payment)) {
            message.error("Error value for pay to artists: " + total_payment).then(() => {
            })
        }

        const param = {
            order_num: values.order_num,
            artwork_price: values.artwork_price,
            promo: 0,
            shipping_cost: 0,
            revart_commission: values.revart_commission,
            pay_to_artist: total_payment.toFixed(2), //rounded to two decimal float
            last_updated: today,
            pay_status: values.pay_status,
            artist: props.artistId
        }
        if (ref && ref.current) {
            ref.current.setFieldsValue({pay_to_artist: total_payment})
        }
        setActionLoading(true)
        let request
        request = postArtistPayments(param)
        request
            .then((response) => {
                message.success('Added successfully').then((r) => {
                })
                onCancelButtonClick()
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            setActionLoading(false)
        })
    }

    const findPayment = (values) => {
        if (!ref || !ref.current || !orderNum) return
        let order_num_val = orderNum
        if (order_num_val) {
            setLoading(true)
            getArtistSaleReport(order_num_val)
                .then((response) => {
                    const artist = artistNames.filter((name) => {
                        //get the artist with this id
                        return name.artist_id == response.data.artist
                    })
                    if (artist.length === 0) return
                    ref.current.setFieldsValue({
                        artwork_price: response.data.sku_price,
                        name: artist[0].artist_id + " " + artist[0].name,
                        order_status: response.data.order_status
                    })
                })
                .catch((error) => {
                    HttpError(error)
                    ref.current.setFieldsValue({
                        artwork_price: '',
                        name: '',
                        order_status: ''
                    })
                }).finally(() => {
                setLoading(false)
            })
        }
    }

    return (
        <Spin size='large' spinning={loading}>
            <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                <Col>
                    <Title style={{marginBottom: 16}}>
                        <FileAddOutlined style={{marginRight: 8}}/>
                        New Payment
                    </Title>
                </Col>
            </Row>
            {!props.artistId && (
                <Alert type={'error'} message={'No artist was selected'}/>
            )}
            <Form layout="vertical" onFinish={submitPayment} ref={ref}
                  style={{padding: 12, marginTop: 12, marginLeft: 'auto', marginRight: 'auto', maxWidth: 840}}>
                <Space style={{display: 'flex', alignItems: 'center'}}>
                    <Form.Item
                        name='order_num'
                        label='Order #'
                        onChange={(e) => {
                            setOrderNum(e.target.value)
                        }}
                    >
                        <Input/>
                    </Form.Item>
                    <Button
                        type='ghost'
                        size='middle'
                        style={{marginTop: 22}}
                        onClick={findPayment}
                    >
                        Find
                    </Button>
                </Space>
                <Form.Item name='name' label='Name'>
                    <Select
                        showSearch
                        placeholder='Enter name'
                        optionFilterProp='children'
                    >
                        {artistNames?.map((artist) => (
                            <Select.Option key={artist.artist_id} value={artist.artist_id}>
                                {artist.artist_id + " " + artist.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <h5>(Enter only numeric value when entering costs)</h5>
                <Form.Item
                    required={true}
                    name='artwork_price'
                    label='Artwork Price'
                    rules={[
                        {
                            type: 'number',
                            transform: (value) => {
                                if (!value) return 0
                                return Number(value)
                            }
                        }
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    required={true}
                    name='revart_commission'
                    label='RevArt Commission'
                    rules={[
                        {
                            type: 'number',
                            transform: (value) => {
                                if (!value) return 0
                                return Number(value)
                            }
                        }
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    name='pay_to_artist'
                    label='Pay to Artist'
                    rules={[
                        {
                            type: 'number',
                            transform: (value) => {
                                if (!value) return 0
                                return Number(value)
                            }
                        }
                    ]}
                >
                    <Input disabled={true}/>
                </Form.Item>
                <Form.Item
                    name='pay_status'
                    label='Status'
                    required={true}
                    requiredMark={true}
                >
                    <Select
                        placeholder='Please select a status'
                    >
                        <Option value='unverified'>Unverified</Option>
                        <Option value='initiated'>Initiated</Option>
                        <Option value='payment-processing'>Payment Processing</Option>
                        <Option value='payment-settled'>Payment Settled</Option>
                    </Select>
                </Form.Item>
                <Row style={{display: 'flex', width: '100%', flexDirection: 'row'}}>
                    <Button danger onClick={onCancelButtonClick} style={{marginRight: 'auto',}}>
                        Cancel Changes
                    </Button>
                    <Button type='primary' htmlType='submit' style={{marginLeft: 'auto',}}
                            loading={actionLoading}
                            disabled={actionLoading}
                    >
                        Save Changes
                    </Button>
                </Row>
            </Form>
        </Spin>
    )
}